import { trigger } from '../util/DOM';

const CONTAINER = Symbol('CONTAINER');
const CHILDREN = Symbol('CHILDREN');
const OPTIONS = Symbol('OPTIONS');
const INDEX = Symbol('INDEX');
const STATE = Symbol('STATE');
const DIRECTION = Symbol('DIRECTION');

class Slider {
  constructor(container, options) {
    this.init(container, {
      interval: 3000,
      initClassName: 'slider-set',
      childSelector: '.slider__item',
      ...options,
    });
  }

  init(container, options) {
    this[CONTAINER] = container;
    this[OPTIONS] = options;
    this[INDEX] = 0;

    const { childSelector, initClassName } = this.options;
    this[CHILDREN] = (
      childSelector
        ? this.container.querySelectorAll(childSelector)
        : this.container.children
    );

    this.container.classList.add(initClassName);
    this.container.slider = this;
    setTimeout(() => this.render(), 100);
  }

  get container() {
    return this[CONTAINER];
  }

  get options() {
    return this[OPTIONS];
  }

  get direction() {
    return this[DIRECTION] || 0;
  }

  get state() {
    return this[STATE] || {
      isPlayng: false,
    };
  }

  get index() {
    return this[INDEX];
  }

  set index(i) {
    const dir = i < this[INDEX] ? -1 : +1;
    if (i >= this.children.length) {
      this[INDEX] = 0;
    } else if (i < 0) {
      this[INDEX] = this.children.length - 1;
    } else {
      this[INDEX] = i;
    }
    this[DIRECTION] = dir;
    this.render();
    setTimeout(() => {
      if (!this.state.isPlayng) {
        this[DIRECTION] = 0;
      }
    }, 100);
  }

  get children() {
    return [...this[CHILDREN]];
  }

  get currentElement() {
    return this.children[this.index];
  }

  get prevElement() {
    if (this.index === 0) {
      return this.children[this.children.length - 1];
    }
    return this.children[this.index - 1];
  }

  get nextElement() {
    if (this.index === this.children.length - 1) {
      return this.children[0];
    }
    return this.children[this.index + 1];
  }

  goTo(index) {
    const { isPlayng, id } = this.state;
    if (isPlayng) {
      this[STATE] = {
        ...this.state,
        id: clearInterval(id),
      };
    }
    this.index = index;
    if (isPlayng) {
      this.play();
    }
    return this;
  }

  goPrev() {
    return this.goTo(this.index - 1);
  }

  goNext() {
    return this.goTo(this.index + 1);
  }

  play() {
    if (this.children.length === 1) {
      return this.pause();
    }
    this[STATE] = {
      ...this.state,
      id: setInterval(() => this.goNext(), this.options.interval),
      isPlayng: true,
    };
    return this;
  }

  pause() {
    const { id } = this.state;

    this[STATE] = {
      ...this.state,
      id: clearInterval(id),
      isPlayng: false,
    };

    return this;
  }

  on(name, fn, el) {
    if (!el) {
      this.container.addEventListener(name, fn);
      return this;
    }

    this.container.addEventListener(name, (e) => {
      for (let { target } = e; target && target !== this.container; target = target.parentNode) {
        if (target.matches(el)) {
          fn.call(target, e);
          break;
        }
      }
    }, false);

    return this;
  }

  trigger(name, detail) {
    trigger(this.container, name, {
      ...detail, slider: this,
    });
  }

  render() {
    if (!this.children.length) {
      // eslint-disable-next-line no-console
      console.trace('Elementos filhos não encontrados.', this);
      this.pause();
      return;
    }

    this.children.forEach((slide) => {
      slide.classList.remove('prev');
      slide.classList.remove('next');
      slide.classList.remove('current');
    });
    this.currentElement.classList.add('current');
    this.prevElement.classList.add('prev');
    this.nextElement.classList.add('next');
    this.trigger('render');
  }
}

export default Slider;
